import { FC, useMemo, useState } from 'react'

interface AbbreviatedTextProps {
  text: string
  maxLength: number
}

export const AbbreviatedText: FC<AbbreviatedTextProps> = ({ text, maxLength }) => {
  const [showFullText, setShowFullText] = useState(false)

  const abbreviatedText = useMemo(() => {
    return showFullText ? text : text.slice(0, maxLength) + (text.length > maxLength ? '...' : '')
  }, [showFullText, text, maxLength])

  return (
    <span
      title={showFullText ? '' : text}
      onMouseEnter={() => setShowFullText(true)}
      onMouseLeave={() => setShowFullText(false)}
    >
      {abbreviatedText}
    </span>
  )
}
